import type { IconNode } from '../types';

/**
 * @name zodiac-taurus
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE1IiByPSI2IiAvPgogIDxwYXRoIGQ9Ik0xOCAzQTYgNiAwIDAgMSA2IDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/zodiac-taurus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ZodiacTaurus: IconNode = [
  ['circle', { cx: '12', cy: '15', r: '6' }],
  ['path', { d: 'M18 3A6 6 0 0 1 6 3' }],
];

export default ZodiacTaurus;
